module.exports = __webpack_public_path__ + "img/1-07.0a585434.png";